export let mixinValidate = {
  data() {
    return {
    };
  },
  components: {
  },
  mounted() {
  },
  methods: {
    checkphone(rule, value, callback) {
      // let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
       if (value && !this.isCellPhone(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    },
    checkfloat(rule, value, callback) {
      let floatReg = /^[+-]?[0-9]+(\.[0-9]{1,4})?$/ 
      if (value && !floatReg.test(value)) {
        callback(new Error('请输入正确的数字'));
      } else {
        callback();
      }
    },
    checkInt(rule, value, callback) {
      let floatReg = /^(?:0|(?:-?[1-9]\d*))$/ 
      if (value && !floatReg.test(value)) {
        callback(new Error('请输入整数'));
      } else {
        callback();
      }
    },
    checkhcnum(rule, value, callback) {
      let testReg = /^[23]\d[12][012]\d[012]\d{4}$/ 
       if (value && !testReg.test(value)) {
        //引入methods中封装的检查手机格式的方法
        callback(new Error('请输入正确的耗材编号'));
      } else {
        callback();
      }
    },
  }
};
